<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('affiliateWithdrawal.queryCondition') }}</span>
      </div>
      <el-row :gutter="20">
        <el-col :span="6">
          <el-input
            v-model="affiliateWithdrawalInfo.conditions.userName"
            :placeholder="$t('affiliateWithdrawal.pleaseEnterAffiliate')"
            clearable
          />
        </el-col>
        <el-col :span="2">
          <el-button
            type="primary"
            @click="_queryAffiliateUserMethod"
            icon="el-icon-search"
          >
            {{ $t('affiliateWithdrawal.query') }}
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-card class="box-card">
      <div slot="header" class="flex justify-between">
        <span>{{ $t('affiliateWithdrawal.withdrawal') }}</span>
      </div>
      <el-table
        :data="affiliateWithdrawalInfo.affiliateWithdrawals"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="awId"
          :label="$t('affiliateWithdrawal.withdrawalId')"
          align="center"
        />
        <el-table-column
          prop="auId"
          :label="$t('affiliateWithdrawal.affiliateId')"
          align="center"
        />
        <el-table-column
          prop="userName"
          :label="$t('affiliateWithdrawal.affiliate')"
          align="center"
        />
        <el-table-column
          prop="realName"
          :label="$t('affiliateWithdrawal.realName')"
          align="center"
        />
        <el-table-column
          prop="alipayAccount"
          :label="$t('affiliateWithdrawal.alipayAccount')"
          align="center"
        />
        <el-table-column

          prop="amount"
          :label="$t('affiliateWithdrawal.withdrawalAmount')"
          align="center"
        />
        <el-table-column
          prop="realAmount"
          :label="$t('affiliateWithdrawal.actualAmount')"
          align="center"
        />
        <el-table-column
          prop="fee"
          :label="$t('affiliateWithdrawal.fee')"
          align="center"
        />
        <el-table-column
          prop="accountType"
          :label="$t('affiliateWithdrawal.accountType')"
          align="center"
        >
          <template slot-scope="scope">
            {{ _account_type(scope.row.accountType) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="state"
          :label="$t('affiliateWithdrawal.status')"
          align="center"
        >
          <template slot-scope="scope">
            {{ _state(scope.row.state) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="auditRemark"
          :label="$t('affiliateWithdrawal.auditRemark')"
          align="center"
        />
        <el-table-column
          prop="completeTime"
          :label="$t('affiliateWithdrawal.completeTime')"
          align="center"
        />
        <el-table-column
          prop="createTime"
          :label="$t('affiliateWithdrawal.createTime')"
          align="center"
        />
        <el-table-column
          :label="$t('affiliateWithdrawal.operation')"
          align="center"
        >
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.state == '0' || scope.row.state == '1'"
              type="text"
              size="small"
              @click="_openAuditAffiliateWithdrawalModel(scope.row)"
            >
              {{ $t('affiliateWithdrawal.audit') }}
            </el-button>
            <el-button
              v-if="scope.row.state != '3'"
              type="text"
              size="small"
              @click="_openDeleteAffiliateWithdrawalModel(scope.row)"
            >
              {{ $t('affiliateWithdrawal.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="affiliateWithdrawalInfo.conditions.page"
        :page-size="affiliateWithdrawalInfo.conditions.row"
        layout="total, prev, pager, next"
        :total="affiliateWithdrawalInfo.total"
      />
    </el-card>

    <audit-affiliate-withdrawal ref="auditAffiliateWithdrawal" />
    <delete-affiliate-withdrawal ref="deleteAffiliateWithdrawal" />
  </div>
</template>

<script>
import { listAffiliateWithdrawal } from '@/api/affiliate/affiliateWithdrawalApi'
import AuditAffiliateWithdrawal from '@/components/affiliate/auditAffiliateWithdrawal'
import DeleteAffiliateWithdrawal from '@/components/affiliate/deleteAffiliateWithdrawal'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'AffiliateWithdrawalManage',
  components: {
    AuditAffiliateWithdrawal,
    DeleteAffiliateWithdrawal
  },
  data() {
    return {
      affiliateWithdrawalInfo: {
        affiliateWithdrawals: [],
        total: 0,
        conditions: {
          page: 1,
          row: 10,
          userName: '',
          amount: '',
          state: ''
        }
      },
      shopId: ''
    }
  },
  created() {
    this._listAffiliateWithdrawals()
    this.shopId = getShopId()
    console.log(this.shopId)
  },
  methods: {
    async _listAffiliateWithdrawals() {
      try {
        const res = await listAffiliateWithdrawal(this.affiliateWithdrawalInfo.conditions)
        this.affiliateWithdrawalInfo.affiliateWithdrawals = res.data
        this.affiliateWithdrawalInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _openAuditAffiliateWithdrawalModel(row) {
      this.$refs.auditAffiliateWithdrawal.open(row)
    },
    _openDeleteAffiliateWithdrawalModel(row) {
      this.$refs.deleteAffiliateWithdrawal.open(row)
    },
    _queryAffiliateUserMethod() {
      this.affiliateWithdrawalInfo.conditions.page = 1
      this._listAffiliateWithdrawals()
    },
    handleCurrentChange(val) {
      this.affiliateWithdrawalInfo.conditions.page = val
      this._listAffiliateWithdrawals()
    },
    _state(state) {
      const states = {
        '0': this.$t('affiliateWithdrawal.applying'),
        '1': this.$t('affiliateWithdrawal.processing'),
        '2': this.$t('affiliateWithdrawal.completed'),
        '3': this.$t('affiliateWithdrawal.rejected')
      }
      return states[state] || state
    },
    _account_type(type) {
      const types = {
        '1': this.$t('affiliateWithdrawal.alipay'),
        '2': this.$t('affiliateWithdrawal.wechat'),
        '3': this.$t('affiliateWithdrawal.bankCard')
      }
      return types[type] || type
    }
  }
}
</script>

<style scoped>
.box-card {
  margin-bottom: 20px;
}
</style>
